import { SubscriptionPlanDetailModel } from './subscription.plan.detail.model';
export class PagedSubscriptionPlanDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: SubscriptionPlanDetailModel[] = [];
}
